import { Directive, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

@UntilDestroy()
@Directive({
    selector: '[atsGlobalEvent]',
    standalone: false
})
export class AtsGlobalEventDirective implements OnDestroy, OnInit {
	@Input('atsGlobalEvent') name!: string;
	@Input() atsGlobalDispatch!: Observable<void>;
	@Input() atsGlobalCallback?: Function;
	private eventHandler!: Function;

	constructor(private renderer: Renderer2) {}

	ngOnInit() {
		const event: any = new Event(this.name);
		this.eventHandler = this.renderer.listen('document', this.name, () => {
			if (this.atsGlobalCallback) this.atsGlobalCallback();
		});

		this.atsGlobalDispatch.pipe(untilDestroyed(this), delay(50)).subscribe(() => {
			document.dispatchEvent(event);
		});
	}
	ngOnDestroy() {
		this.eventHandler();
	}
}
